export default function showModal(success = true) {
  const params = success
    ? {
        title: 'Спасибо!',
        text:
          'Мы получили ваше сообщение, и свяжемся с вами в ближайшее время.',
        buttons: [
          {
            title: 'Закрыть',
          },
        ],
      }
    : {
        title: 'Что-то пошло не так!',
        text:
          'Не получилось обработать Ваш запрос. Вы можете связаться с нами, отправив письмо на почту <a href="mailto:hr@interesnee.ru">hr@interesnee.ru</a>, или попробовать позже.',
        buttons: [
          {
            title: 'Закрыть',
          },
        ],
      };
  this.$modal.show('dialog', params);
}



// WEBPACK FOOTER //
// ./src/helpers.js